module.exports = __webpack_public_path__ + "static/media/pic-svg-16.ed368095.svg";